export const version = 2;
export const cookieName = 'user-preferences';
export const defaultCity = {
  label: 'Los Angeles,CA',
  value: 'Los Angeles',
  type: 'city',
  market: 'Los Angeles',
  id: null,
  coordinates: {
    latitude: '34.05223',
    longitude: '-118.24368',
  },
};
export const defaultPaymentMethod = {
  label: 'Credit Card',
  brand: 'card',
  value: 'newCard',
};

export const availablePaymentMethods = [
  {
    options: [
      {
        // need somehow to pass vars here.
        label: 'Credits',
        brand: 'none',
        value: 'credits',
      },
    ],
  },
  {
    label: 'Add payment method',
    options: [
      {
        label: 'Credit Card',
        brand: 'card',
        value: 'newCard',
      },
      {
        label: 'PayPal',
        brand: 'paypal',
        value: 'paypal',
      }
    ],
  },
];
